/* eslint-disable */
import React, {PropTypes} from 'react';
import Helpers from '../../util/Helpers'

import {Chart, Bar} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';


class GraficoBarraTotalNaturezaPeriodo extends React.Component {

        constructor(props, context) {
            super(props, context);

            this.state = {
                idNatureza: 0,
                
            };
            
            this.getNatureza = this.getNatureza.bind(this);
        }

        // componentDidMount() {
        //     
        //     //console.log(' this.refs.chart.chart_instance ', this.refs.chart.chart_instance);
        //     //esse é a instância correta, os outros não deverão existir. 
        //     Chart.pluginService.register({
        //         afterDraw: (chartInstance) => {
        //             
        //                 if(chartInstance){
        //                     //console.log('chartInstance', chartInstance);
        //                     //console.log('this.refs.chartNatureza', this.refs.chartNatureza);
        //                     let ctx = chartInstance.chart.ctx;
        //                     ctx.font = "10px Verdana";
        //                     ctx.fillStyle = "#00000";
        //                     ctx.textAlign = "center";
        //                     ctx.textBaseline = "bottom";
        //                     
                            
        //                         chartInstance.chart.config.data.datasets.forEach(function (dataset) {
        //                         
        //                         const dataArray = dataset.data;
        //                         if(dataset._meta[chartInstance.id]){
        //                             
        //                             dataset._meta[chartInstance.id].data.forEach(function (bar, index) {

        //                                 if(bar._chart.config.type==='bar'){
        //                                     if(dataArray[index]>0){
        //                                         ctx.fillText(dataArray[index], bar._view.x, bar._view.y);
        //                                     }
        //                                 } else if(bar._chart.config.type==='line'){
        //                                     if(dataArray[index]>0){
        //                                         ctx.fillText(dataArray[index], bar._view.x, bar._view.y-5);
        //                                     }
        //                                 }
        //                                 else if(bar._chart.config.type ==='horizontalBar'){
        //                                     ctx.fillText(dataArray[index], bar._view.x+8, bar._view.y+5);
        //                                 }

        //                             });
        //                         }
        //                     })
        //                 }
        //             }
        //         });
        //     }

        alerta(titulo, mensagem, tipo, posicao) {
            
            // this.props.actionsAlerta.apresentarAlerta({
            //     title: titulo !== null ? titulo : 'Aviso!',
            //     message: mensagem !== null ? mensagem : '',
            //     level: tipo !== null ? tipo : 'error',
            //     position: posicao !== null ? posicao : 'tc',
            //     showMsg: true,
            //     autoDismiss: 25
            // });
        }

        getNatureza(obj) {
            
            if (obj.length > 0) {
                
                //metodo da dashboard que passará o id para a modal. 
                //console.log('clicou em q gráfico ',this.props.relatorio.dado[obj[0]._index].mClassificacaoOperador);
                this.props.obtemNaturezaSelecionada(this.props.classificacoes[obj[0]._index])
            }

        }


    render() {
      if(this.props.classificacoes===null){
          return <div className='col-lg-12 col-centered'>Não existem manifestações neste período.</div>
      }
      var valorTotal = 0;
      var totalMensagensNaoResponsabilidadeSebrae = 0;

      var classificacoesDenuncia = this.props.classificacoes.filter(v => v.id === 1);
      var totalDenunciasNaoResponsabilidadeSebrae = classificacoesDenuncia[0].totalMensagensNaoResponsabilidadeSebrae;      
      
         for(var i = 0, len = this.props.classificacoes.length; i < len; i++) {
             valorTotal += this.props.classificacoes[i].total;
             totalMensagensNaoResponsabilidadeSebrae += this.props.classificacoes[i].totalMensagensNaoResponsabilidadeSebrae
         }

         const dataBar = {
             labels: this.props.classificacoes.map(item => {
                 
                 //console.log('item descricao', item.descricao !== null ? item.descricao : 'Sem classificar');
                 return item.descricao !== null ? item.descricao + ' ' : 'Sem classificar'
             }),
             datasets: [{
                 data: this.props.classificacoes.map(item => {
                     return item.total
                 }),
                 datalabels: {
                     align: 'end',
                     anchor: 'end'
                 },
                 label: 'Total',
                 borderWidth: 1,
                 hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                 hoverBorderColor: 'rgba(255,99,132,1)',
                 backgroundColor: this.props.classificacoes.map(item => {
                     return Helpers.obterCoresNaturezaRGBa(item.descricao, '0.8') //+ ' - ' + item.mTotalMensagens 
                 }),
                 borderColor: this.props.classificacoes.map(item => {
                     return Helpers.obterCoresNaturezaRGBa(item.descricao, '0.1') //+ ' - ' + item.mTotalMensagens 
                 }),
                 hoverBackgroundColor: this.props.classificacoes.map(item => {
                     return Helpers.obterCoresNaturezaRGBa(item.descricao, '0.9') //+ ' - ' + item.mTotalMensagens 
                 }),
                 hoverBorderColor: this.props.classificacoes.map(item => {
                     return Helpers.obterCoresNaturezaRGBa(item.descricao, '1') //+ ' - ' + item.mTotalMensagens 
                 }),
             }]

            };
            const optionsBar = {
                plugins: {
                    datalabels: {
                        backgroundColor: function(context) {
                            return context.dataset.backgroundColor;
                        },
                        borderRadius: 4,
                        color: 'white',
                        font: {
                            weight: 'bold'
                        },
                        formatter: Math.round
                    }
                },scales: {
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    xAxes: [{
                        barPercentage: 0.5,
                        barThickness: 35,
                        maxBarThickness: 35,
                        minBarLength: 1,
                        gridLines: {
                            offsetGridLines: true
                        }
                    }]
                },
                title: {
                    display: true,
                    text: 'Quantitativo de manifestações por natureza - '+ valorTotal,

                },
                legend: {
                    display: false,
                    labels: {
                        fontColor: '#000000',
                        fontSize: 8
                    }

                },
                maintainAspectRatio: true,
                showDatapoints: true,
                tooltips:{
                    enabled:true
                }
            };
    let msgNaoResponsabilidade = "";
    if(totalDenunciasNaoResponsabilidadeSebrae>0){
        msgNaoResponsabilidade = <div style={{ fontSize:  '12px', textAlign: 'center'  }} >{"Sendo que "+ totalDenunciasNaoResponsabilidadeSebrae +" denúncias não são de responsabilidade do SEBRAE"}</div>
    }
     return (
        <div>
                <Bar ref='chartNatureza'
                    data={dataBar}
                    onElementsClick={this.getNatureza}
                    options={optionsBar}
                 />
                 {msgNaoResponsabilidade}
        </div>
        
    );
  }
}


export default GraficoBarraTotalNaturezaPeriodo;


/** WEBPACK FOOTER **
 ** ./src/components/relatorios/Natureza/GraficoBarraTotalNaturezaPeriodo.js
 **/